@let progressbar = config().body.progressbar;
@let pastille = config().body.rewardPastille;

<div class="stepper-container" data-cy="stepper" data-variant="variant4">
  <div class="line">
    <p
      class="key"
      [style]="{
        color: progressbar.labelColor,
        fontFamily: progressbar.labelFontFamily,
      }"
    >
      {{ progressbar.earnLabel }}
    </p>

    <ul class="steps rewards" [class.single]="challenge().targets.length === 1">
      @for (step of challenge().steps; track $index; let i = $index) {
        @let stepStatus = challenge() | stepStatus: i;
        @let isUnreached = stepStatus === StepStatus.UNREACHED;
        <li data-cy="active_step_img">
          <b2c-reward-sticker
            class="reward"
            [amount]="step.reward"
            [amountColor]="config().body.rewards.color ?? ''"
            [amountFontFamily]="config().body.rewards.fontFamily"
            [imageUrl]="
              isUnreached ? pastille.offIcon.imageUrl : pastille.onIcon.imageUrl
            "
            [alternativeText]="
              (isUnreached
                ? pastille.offIcon.alternativeText
                : pastille.onIcon.alternativeText
              ) | replaceVars: step.reward
            "
            [checkIconUrl]="
              stepStatus === StepStatus.DEFAULT
                ? pastille.checkIcon.imageUrl
                : undefined
            "
          />
        </li>
      }
    </ul>
  </div>

  <div class="line spend">
    <p
      class="key"
      [style]="{
        color: progressbar.labelColor,
        fontFamily: progressbar.labelFontFamily,
      }"
    >
      {{ progressbar.spendLabel }}
    </p>

    <div class="track">
      <div class="bar" [style.backgroundColor]="progressbar.containerColor">
        <div
          class="bar-value"
          data-cy="progress-bar"
          [style]="{
            width: challenge() | progressWidth: limitsPerNbSteps,
            backgroundColor: progressbar.progressColor,
          }"
        ></div>
      </div>

      <ul
        class="steps targets"
        [class.single]="challenge().targets.length === 1"
      >
        @for (step of challenge().steps; track $index; let i = $index) {
          @let isUnreached =
            (challenge() | stepStatus: i) === StepStatus.UNREACHED;
          <li
            class="target"
            [attr.data-cy]="isUnreached ? 'target_coming' : 'target_reached'"
          >
            <span
              class="dot"
              aria-hidden="true"
              [style.backgroundColor]="
                isUnreached
                  ? progressbar.containerColor
                  : progressbar.progressColor
              "
            ></span>
            <span
              class="amount"
              [style]="{
                color: progressbar.labelColor,
                fontFamily: config().body.targetsFontFamily,
              }"
            >
              {{ step.target | formatAmount: 'currency' : 0 }}
            </span>
          </li>
        }
      </ul>
    </div>
  </div>
</div>
